import * as THREE from 'three'
import vertexShader from '../shaders/quad.vert'
import fragmentShader from '../shaders/background.frag'

/**
 * Full-screen gradient plane sitting behind everything else.
 * Sized from the camera frustum at its own depth so it always fills the viewport exactly.
 */
export default class Background extends THREE.Mesh {
	constructor(depth = -50) {
		super(
			new THREE.PlaneGeometry(1, 1),
			new THREE.ShaderMaterial({
				vertexShader,
				fragmentShader,
				uniforms: {
					uBase: { value: new THREE.Color('#0f0f11') },
					uGlow: { value: new THREE.Color('#4bb5f1') },
					uHalo: { value: new THREE.Color('#173148') },
				},
				depthWrite: false,
			})
		)
		this.position.z = depth
		this.renderOrder = -1
	}

	/** Fit the plane to the visible frustum at this depth. */
	resize(camera) {
		const distance = camera.position.z - this.position.z
		const visibleHeight = 2 * distance * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2))
		this.scale.set(visibleHeight * camera.aspect, visibleHeight, 1)
	}
}
